<script>
import baseMixin from '@/mixins/baseMixin'
import EmptyStateBlock from '../general/empty-state-block.vue'

export default {
  name: 'FileNotFoundBlock',
  components: { EmptyStateBlock },
  mixins: [baseMixin],
}
</script>

<template>
  <EmptyStateBlock>
    <template v-slot:icon>
      <v-icon color="white" class="mb-5" size="62">
        mdi-file-document-alert-outline
      </v-icon>
    </template>
    <template v-slot:title>
      <h2 class="white--text mb-2 font-weight-medium">{{
        $t('error.fileNotAvailableEmptyStateTitle')
      }}</h2>
    </template>
    <template v-slot:description>
      <p class="text-subtitle-1 white--text">{{
        $t('error.fileNotAvailableEmptyStateDescription')
      }}</p>
    </template>
    <template v-slot:button>
      <section class="mt-4">
        <v-btn
          data-testid="file-not-found-block-retry-btn"
          color="primary"
          class="white--text"
          depressed
          large
          @click="$emit('retry')"
        >
          <v-icon left> mdi-refresh </v-icon>
          {{ $t('general.retryBtnText') }}
        </v-btn>
      </section>
    </template>
  </EmptyStateBlock>
</template>
